var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavoritedIconUserCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18C9.20666 17.9996 8.92021 17.9086 8.67793 17.7389C5.08867 15.2381 3.5345 13.5234 2.67726 12.4514C0.850438 10.1663 -0.024155 7.82016 0.000507135 5.27953C0.0292796 2.36813 2.30505 0 5.0736 0C7.08676 0 8.48109 1.16391 9.29311 2.13328C9.31884 2.16368 9.35062 2.18805 9.38631 2.20476C9.422 2.22146 9.46077 2.23011 9.5 2.23011C9.53923 2.23011 9.578 2.22146 9.61369 2.20476C9.64938 2.18805 9.68117 2.16368 9.70689 2.13328C10.5189 1.16297 11.9132 0 13.9264 0C16.695 0 18.9707 2.36812 18.9995 5.28C19.0242 7.82109 18.1486 10.1672 16.3227 12.4519C15.4655 13.5239 13.9113 15.2386 10.3221 17.7394C10.0797 17.9089 9.7933 17.9998 9.5 18Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritedIconUserCard);
export default __webpack_public_path__ + "static/media/favorited-icon-user-card.e81420843e0b8097c2077a254f8f5f92.svg";
export { ForwardRef as ReactComponent };